module.exports = __webpack_public_path__ + "img/icon7.6fcf99f.png";